// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": false,
    "raw": "v20.1.111-0-gd34f8bfb",
    "hash": "gd34f8bfb",
    "distance": 0,
    "tag": "v20.1.111",
    "semver": {
        "options": {
            "loose": false,
            "includePrerelease": false
        },
        "loose": false,
        "raw": "v20.1.111",
        "major": 20,
        "minor": 1,
        "patch": 111,
        "prerelease": [],
        "build": [],
        "version": "20.1.111"
    },
    "suffix": "0-gd34f8bfb",
    "semverString": "20.1.111",
    "version": "20.1.111"
};
/* tslint:enable */
